import axios from 'axios';

// Get API URL from environment variables
// Supports: REACT_APP_API_URL, REACT_APP_BACKEND_URL, REACT_APP_BASE_URL
const defaultApiUrl = '/api';
const rawApiUrl = String(
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_BASE_URL ||
    defaultApiUrl
).trim();

// Ensure normalized API URL without trailing slash
export const API_URL = rawApiUrl ? rawApiUrl.replace(/\/+$/, '') : '';

// Base root origin URL (strips trailing /api if present) for static uploads/media
export const API_BASE_URL = !API_URL || API_URL.startsWith('/') ? 'https://rahbercorporation.com' : API_URL.replace(/\/api\/?$/, '');

// Create axios instance
const api = axios.create({
    baseURL: API_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor - Add auth token to requests if needed
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - Handle common errors
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle network errors
        if (!error.response) {
            return Promise.reject({
                message: 'Network error. Please check your connection.',
                status: 0,
            });
        }

        const { status, data } = error.response;

        // Extract error message from response
        const errorMessage =
            data?.message ||
            data?.error ||
            'An error occurred. Please try again.';

        return Promise.reject({
            message: errorMessage,
            status,
            data: data || {},
        });
    }
);

export default api;

